import { HttpResponse, http } from 'msw';
import { staticHolidays } from '../../constants/staticHolidays';
import type { APIResp } from '../../types/APIService';
import { getAPIUrl } from '../../utils/getApiUrl';

const API_URL = getAPIUrl();

export const holidaysHandlers = [
  http.get(`${API_URL}holidays`, () => {
    const res: APIResp<string[]> = { data: staticHolidays, status: 'success', message: '' };
    return HttpResponse.json(res);
  }),
];
